import { render } from "./TheCard.vue?vue&type=template&id=314bebf2"
import script from "./TheCard.vue?vue&type=script&lang=js"
export * from "./TheCard.vue?vue&type=script&lang=js"
script.render = render

export default script